module.exports = __webpack_public_path__ + "static/img/vip_icon_1.834dfee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/member/vip_icon_1.png
// module id = 753
// module chunks = 1